module.exports = __webpack_public_path__ + "static/media/Portrait-10058.374cd076.jpg";